var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { customElement, property, query } from 'lit/decorators.js';
import styles from './team-form.styles';
import '@shoelace-style/shoelace/dist/components/color-picker/color-picker.js';
import '@shoelace-style/shoelace/dist/components/input/input.js';
import '../../atoms/delete-button/sgdf-delete-button.js';
import '../../participant/participant-picker/sgdf-participant-picker.js';
import { serialize } from '@shoelace-style/shoelace/dist/utilities/form';
import { ifDefined } from 'lit/directives/if-defined.js';
import { SgdfFormElement } from '../../internal/sgdf-element';
import { classMap } from 'lit/directives/class-map.js';
import { formKey, getFormSchema } from '../team.form';
import { validateKey } from '../../internal/validate-key.js';
let SgdfTeamForm = class SgdfTeamForm extends SgdfFormElement {
    constructor() {
        super(...arguments);
        this.isLoading = false;
        this.participants = [];
    }
    connectedCallback() {
        super.connectedCallback();
        this.onSubmit = this.onSubmit.bind(this);
        this.updateComplete.then(() => {
            this.form.addEventListener('submit', this.onSubmit);
        });
    }
    disconnectedCallback() {
        super.disconnectedCallback();
    }
    handleDelete(e) {
        var _a;
        if ((_a = this.team) === null || _a === void 0 ? void 0 : _a.id) {
            e.stopPropagation();
            this.emit('sgdf-team:delete', {
                detail: {
                    id: this.team.id,
                },
            });
        }
    }
    render() {
        var _a, _b;
        return html `
            <form class="team-form" @submit=${(e) => e.preventDefault()}>
                <div class="team-form-content">
                    <span class="label label-team-name">Nom de l'équipe</span>
                    <div class="team-name">
                        <sl-input
                            class=${classMap({
            'form-error': this.fieldHasError(formKey.label),
        })}
                            name=${validateKey()(formKey.label)}
                            id=${formKey.label}
                            type="text"
                            value=${ifDefined((_a = this.team) === null || _a === void 0 ? void 0 : _a.label)}
                            ?disabled=${this.isLoading}
                        >
                            <small slot="help-text"
                                >${this.readFieldErrors(formKey.label)}</small
                            >
                        </sl-input>
                    </div>
                    <span class="label label-team-members">Membres</span>
                    <div class="team-members">
                        <sgdf-participant-picker
                            .participants=${this.participants}
                            .team=${this.team}
                        ></sgdf-participant-picker>
                    </div>
                    <span class="label label-team-color">Couleur</span>
                    <div class="team-color">
                        <sl-color-picker
                            class=${classMap({
            'form-error': this.fieldHasError(formKey.color),
        })}
                            name=${validateKey()(formKey.color)}
                            id=${formKey.color}
                            value=${ifDefined((_b = this.team) === null || _b === void 0 ? void 0 : _b.color)}
                            ?disabled=${this.isLoading}
                        >
                            <small slot="help-text"
                                >${this.readFieldErrors(formKey.color)}</small
                            >
                        </sl-color-picker>
                    </div>
                    <div class="submit">
                        <sgdf-button primary submit>
                            <sgdf-icon
                                name="floppy-disk"
                                slot="prefix"
                            ></sgdf-icon>
                            Enregistrer
                        </sgdf-button>
                    </div>
                    <div class="delete">
                        <sgdf-delete-button
                            @sgdf-delete=${this.handleDelete}
                            danger
                        ></sgdf-delete-button>
                    </div>
                </div>
            </form>
        `;
    }
    async onSubmit(event) {
        var _a;
        event.preventDefault();
        const schema = getFormSchema();
        const detail = serialize(this.form);
        const result = schema.safeParse(detail);
        if (result.success) {
            if ((_a = this.team) === null || _a === void 0 ? void 0 : _a.id) {
                detail.id = this.team.id;
                this.emit('sgdf-team:update', { detail });
                this.fieldErrors = {};
                this.form.reset();
            }
        }
        else {
            this.fieldErrors = result.error.formErrors.fieldErrors;
        }
    }
};
SgdfTeamForm.styles = styles;
__decorate([
    property({ type: Object, reflect: true })
], SgdfTeamForm.prototype, "team", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], SgdfTeamForm.prototype, "isLoading", void 0);
__decorate([
    property({ type: Array, reflect: true })
], SgdfTeamForm.prototype, "participants", void 0);
__decorate([
    query('.team-form')
], SgdfTeamForm.prototype, "form", void 0);
SgdfTeamForm = __decorate([
    customElement('sgdf-team-form')
], SgdfTeamForm);
export { SgdfTeamForm };
//# sourceMappingURL=team-form.js.map